import LinearProgress from "@mui/material/LinearProgress";
import makeStyles from '@mui/styles/makeStyles';
import logo from "common/assets/logo-with-name.webp";
import { color } from "common/tokens";
import React from "react";

const useStyles = makeStyles({
  root: {
    minHeight: '100%',
    background: color.SURFACE,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 24,
  },
  logo: {
    width: 160,
  },
  bar: {
    width: 160,
    height: 4,
    borderRadius: 2,
    background: color.ACCENT_TINT,
  },
  barIndicator: {
    background: color.ACCENT,
  },
});

const AuthSplash = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <img src={logo} alt={'Mentor To Go'} className={classes.logo}/>
      <LinearProgress classes={{root: classes.bar, bar: classes.barIndicator}}/>
    </div>
  );
};

export default AuthSplash;
